module.exports = __webpack_public_path__ + "static/media/angle-left.38c61ab5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/angle-left.svg
// module id = 272
// module chunks = 0